import React from "react";
import "./Choose.css";

const principles = [
  { title: "Clear role requirements", text: "Start with the duties, essential skills, location, employment terms and expected outcomes so candidates understand the opportunity." },
  { title: "Structured communication", text: "Agree on the selection stages, decision owner and candidate update process before interviews begin." },
  { title: "Careful information handling", text: "Collect only the information needed for recruitment and restrict access to applications and assessment notes." }
];

function WhyChoose() {
  return (
    <section className="quarec-principles" aria-labelledby="quarec-principles-heading">
      <div className="quarec-principles-inner">
        <p className="quarec-principles-eyebrow">How we approach recruitment</p>
        <h2 id="quarec-principles-heading">A clear process for employers and candidates</h2>
        <div className="quarec-principles-grid">
          {principles.map((item, index) => <article className="quarec-principle-card" key={item.title}><span>{String(index + 1).padStart(2, "0")}</span><h3>{item.title}</h3><p>{item.text}</p></article>)}
        </div>
      </div>
    </section>
  );
}
export default WhyChoose;
